import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { ActionsMenu } from '../AccountsUsers/ActionsMenu';
import Modal from '../ModalConversion';

/**
 * Canales suscriptos al newsletter.
 *
 * Cada fila es un registro con su correo destinatario, asunto y mensaje. Se
 * agrega con el boton, que abre el formulario del canal; despues la fila se
 * puede editar o eliminar. Un canal no puede repetirse.
 */
export function ChannelsTable({ channels, available, onChange }) {
  const [editing, setEditing] = useState(null); // { channel_alias, recipient_email, subject, message }
  const [confirmDelete, setConfirmDelete] = useState(null);

  // Canales de distribucion que aun no estan en la tabla.
  const pending = available.filter(c => !channels.some(x => x.channel_alias === c.alias));
  const [selected, setSelected] = useState('');

  const blank = (alias, name) => ({ channel_alias: alias, channel_name: name, recipient_email: '', subject: '', message: '' });

  const openNew = () => {
    if (!selected) return;
    const ch = available.find(c => c.alias === selected);
    setEditing(blank(selected, ch ? (ch.name || ch.alias) : selected));
    setSelected('');
  };

  const openEdit = (row) => setEditing({ ...row });

  const save = () => {
    const exists = channels.some(x => x.channel_alias === editing.channel_alias);
    const next = exists
      ? channels.map(x => (x.channel_alias === editing.channel_alias ? editing : x))
      : [...channels, editing];
    onChange(next);
    setEditing(null);
  };

  const remove = (alias) => {
    onChange(channels.filter(x => x.channel_alias !== alias));
    setConfirmDelete(null);
  };

  return (
    <div>
      <div className="d-flex gap-2 mb-2">
        <select
          className="form-select bg-dark text-white border-secondary py-2"
          value={selected}
          onChange={e => setSelected(e.target.value)}
        >
          <option value="">Selecciona un canal...</option>
          {pending.map(c => (
            <option key={c.alias} value={c.alias}>{c.name || c.alias}</option>
          ))}
        </select>
        <button type="button" className="btn btn-primary" onClick={openNew} disabled={!selected}>
          <FontAwesomeIcon icon={faPlus} className="me-1" /> Agregar canal
        </button>
      </div>

      <div className="modern-table-container">
        <table className="modern-table striped-table">
          <thead>
            <tr>
              <th>Canal</th>
              <th>Correo destinatario</th>
              <th style={{ width: 80 }}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {channels.map(c => (
              <tr key={c.channel_alias}>
                <td className="fw-bold text-white">{c.channel_name || c.channel_alias}</td>
                <td>{c.recipient_email}</td>
                <td>
                  <ActionsMenu
                    // El formulario vive dentro de un modal (overlay z-index 9999);
                    // sin esto el menu queda por detras y no se ve ni se puede pulsar.
                    menuZIndex={10000}
                    items={[
                      { label: 'Editar', onClick: () => openEdit(c) },
                      { label: 'Eliminar', danger: true, onClick: () => setConfirmDelete(c) },
                    ]}
                  />
                </td>
              </tr>
            ))}
            {channels.length === 0 && (
              <tr>
                <td colSpan="3" className="text-center text-white-50 py-3">
                  Todavía no hay canales agregados
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <Modal isOpen={!!editing} onClose={() => setEditing(null)}>
        {editing && (
          <>
            <h5 className="text-white mb-3">Canal: {editing.channel_name || editing.channel_alias}</h5>
            <div className="row g-3">
              <div className="col-12">
                <label className="form-label text-white-50">Correo destinatario *</label>
                <input
                  type="email"
                  className="form-control bg-dark text-white border-secondary py-2"
                  value={editing.recipient_email}
                  onChange={e => setEditing({ ...editing, recipient_email: e.target.value })}
                />
              </div>
              <div className="col-12">
                <label className="form-label text-white-50">Asunto</label>
                <input
                  className="form-control bg-dark text-white border-secondary py-2"
                  value={editing.subject}
                  onChange={e => setEditing({ ...editing, subject: e.target.value })}
                />
              </div>
              <div className="col-12">
                <label className="form-label text-white-50">Mensaje (HTML)</label>
                <textarea
                  rows="6"
                  className="form-control bg-dark text-white border-secondary py-2"
                  value={editing.message}
                  onChange={e => setEditing({ ...editing, message: e.target.value })}
                />
              </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-3">
              <button type="button" className="btn btn-ink-outline" onClick={() => setEditing(null)}>Cancelar</button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={save}
                disabled={!editing.recipient_email.trim()}
              >
                Guardar
              </button>
            </div>
          </>
        )}
      </Modal>

      <Modal isOpen={!!confirmDelete} onClose={() => setConfirmDelete(null)} size="sm">
        <h5 className="text-white mb-2">Eliminar canal</h5>
        <p className="text-white-50">
          ¿Eliminar <strong>{confirmDelete?.channel_name || confirmDelete?.channel_alias}</strong> de la configuración?
        </p>
        <div className="d-flex justify-content-end gap-2 mt-3">
          <button type="button" className="btn btn-ink-outline" onClick={() => setConfirmDelete(null)}>Cancelar</button>
          <button type="button" className="btn btn-primary" onClick={() => remove(confirmDelete.channel_alias)}>
            Eliminar
          </button>
        </div>
      </Modal>
    </div>
  );
}